<template>
  <div>
    <generic-modal
      :height="LoginModalDim.height"
      :width="LoginModalDim.width"
      :padding="LoginModalDim.padding"
      :modalClass="LoginModalDim.modalClass"
      overflowNotNeeded="true"
      v-if="isWelcomeLogin"
    >
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <welcome-login :propsData="modulePropsData"></welcome-login>
      </template>
      <template v-slot:footer> </template>
    </generic-modal>
    <!-- logout modal popup -->
    <generic-modal
      v-if="showLogoutModal"
      @close="handleLogoutPopup()"
      :borderRadius="'8px'"
      :height="LogoutModalDim.height"
      :width="LogoutModalDim.width"
      :padding="LogoutModalDim.padding"
      :paddingTop="LogoutModalDim.paddingTop"
      :paddingBottom="LogoutModalDim.paddingBottom"
      :class="[
        clientPlatform == 'Web'
          ? 'modal-mask  full-screen-popup  lg-screen-centered'
          : 'd-flex justify-content-center align-items-center plr40',
      ]"
    >
      <template v-slot:header></template>
      <template v-slot:body>
        <div class="logout-popup" :class="{ pt20: clientPlatform == 'Web' }">
          <h1 class="fs-16 bold">Logout?</h1>
          <p class="fs-14 plr40">
            You'll have to Login again to place an order.
          </p>
          <div class="logout-line"></div>
          <div class="d-flex justify-content-around align-items-center">
            <span class="fs-14 color-slaty hand" @click="handleLogoutPopup()">
              Cancel
            </span>
            <span class="vl"></span>
            <span class="fs-14 color-error hand" @click="handleLogoutCTA()">
              Logout
            </span>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import LoginInfo from "./LoginInfo.vue";
import WelcomeLogin from "./WelcomeLogin.vue";
import { clientPlatform } from "../config/apiEndpoints";
import { LoginStates } from "../helpers/loginStateConstants";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { EVENT_LOGOUT_CTA_CLICKED } from "../helpers/analyticsEvents";
export default {
  name: "LoginDesktop",
  components: {
    GenericModal,
    WelcomeLogin,
    LoginInfo,
  },
  props: ["moduleProps"],
  data() {
    return {
      modulePropsData: {},
      LoginModalDim: {
        width: "100vw",
        height: "100vh",
        padding: "0px",
        modalClass: "login-modal full-screen-popup  lg-screen-centered",
      },
      clientPlatform,
      LogoutModalDim: {
        width: "100vw",
        height: "auto",
        padding: "0px",
        paddingTop: "0px",
        paddingBottom: "0px",
      },
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.$store.commit(
      keyMapsMutation.UPDATE_LOGIN_PROPS,
      this.modulePropsData
    );
  },
  methods: {
    handleLogoutCTA() {
      EVENT_LOGOUT_CTA_CLICKED();
      this.$store.dispatch(keyMapsAction.ANONYMOUS_USER_API, {
        isLogout: true,
      });
    },
    handleLogoutPopup() {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_PROFILE_DRAWER_MODAL,
        false
      );
    },
  },
  computed: {
    isWelcomeLogin() {
      return (
        this.$store.state.Auth.currentLoginState === LoginStates.welcomeLogin &&
        !LocalStorageFunc.isLoggedIn() &&
        this.$store.state.Auth.showProfileDrawerModal
      );
    },
    showLogoutModal() {
      return (
        this.$store.state.Auth.showProfileDrawerModal &&
        LocalStorageFunc.isLoggedIn()
      );
    },
  },
};
</script>
